module.exports = __webpack_public_path__ + "img/hand.472f55d1.png";